export default __webpack_public_path__ + "static/media/P2.1db1bc69.svg";